const autocompleteModalFilterService = {
  site: 'Sitios',
  equipments: 'Tipo del Equipo',
  equipmentGroups: 'Grupo del Equipo',
  place: 'Lugar',
  area: 'Departamentos',
  serviceTypes: 'Tipo de servicio',
  companies: 'Tercera empresa',
  frequencies: 'Periodicidad',
  performedBy: 'Realizado por',
  doneInDelay: 'Mostrar solo los servicios que se realizaron con retraso'
};

export default autocompleteModalFilterService;
